const PATH = '[DIRECT_SALE_CONTACTS_MANAGER]';

export const DirectSaleContactsManagerActions = {
  TOGGLE_FORM: `${PATH} TOGGLE_FORM`,
  TOGGLE_CREATE_FORM: `${PATH} TOGGLE_CREATE_FORM`,
  TOGGLE_EDIT_FORM: `${PATH} TOGGLE_EDIT_FORM`,
  TOGGLE_DELETE: `${PATH} TOGGLE_DELETE`,
  GET_STATE_FROM_API: `${PATH} GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH} GET_STATE_FROM_API_SUCCESS`,
  GET_STATE_FROM_API_FAIL: `${PATH} GET_STATE_FROM_API_FAIL`,
  CHANGE_CONTROLS: `${PATH} CHANGE_CONTROLS`,
  // create
  CREATE_CONTACT: `${PATH} CREATE_CONTACT`,
  CREATE_CONTACT_SUCCESS: `${PATH} CREATE_CONTACT_SUCCESS`,
  CREATE_CONTACT_FAIL: `${PATH} CREATE_CONTACT_FAIL`,
  // update
  EDIT_CONTACT: `${PATH} EDIT_CONTACT`,
  EDIT_CONTACT_SUCCESS: `${PATH} EDIT_CONTACT_SUCCESS`,
  EDIT_CONTACT_FAIL: `${PATH} EDIT_CONTACT_FAIL`,
  // delete
  DELETE_CONTACT: `${PATH} DELETE_CONTACT`,
  DELETE_CONTACT_SUCCESS: `${PATH} DELETE_CONTACT_SUCCESS`,
  DELETE_CONTACT_FAIL: `${PATH} DELETE_CONTACT_FAIL`,
};
